if (sessionStorage.getItem('preloader-loaded') !== 'true') {
  sessionStorage.setItem('preloader-loaded', 'true');
  document.getElementById('preloader')?.classList.add('fade-away');
}
